import { faQuoteLeft, faUser, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, makeStyles, Typography, Button } from '@material-ui/core';
import React, { useState, useRef } from 'react';
//import { deleteCandidateQuote } from '../../../api/candidate';
import { updateQuote } from '../../../api/quote';
import { QUOTE } from '../../../constants/props';
import Input from '../../common/input';
import useNotifications from '../../../hooks/useNotification'

const useStyles = makeStyles({
  container: {
    marginLeft: '1.625rem',
  },
  quote: {
    fontSize: '1.5rem',
  },
});

const Edit = ({ hash, author: initialAuthor, position: initialPosition, company: initialCompany, 
  comment: initialComment, onDelete,reloadCandidateUpdatedAtData }) => {
  const classes = useStyles();

  let { current: lastAuthor } = useRef(initialAuthor);
  let { current: lastPosition } = useRef(initialPosition);
  let { current: lastCompany } = useRef(initialCompany);
  let { current: lastComment } = useRef(initialComment);

  const [author, setAuthor] = useState(initialAuthor);
  const [position, setPosition] = useState(initialPosition);
  const [company, setCompany] = useState(initialCompany);
  const [comment, setComment] = useState(initialComment);
  const notifications = useNotifications();

  function handleSubmit() {
    if (lastAuthor !== author ||
        lastPosition !== position ||
        lastCompany !== company ||
        lastComment !== comment) {
      updateQuote(hash, { immediately: true, author, position, company, comment } ).then((res) => {
        if (res.success) {
          reloadCandidateUpdatedAtData();
          notifications.success({message: 'Quote was successfully updated'});
        }
      });
    }
  }

  function handleDelete() {
    onDelete(hash);
  }

  return (
    <Grid className={classes.root} container direction="row" spacing={2}>
      <Grid className={classes.title} item>
        <FontAwesomeIcon icon={faUser} />
      </Grid>
      <Grid item container direction="column" xs>
        <Typography className={classes.title} variant="button">
          <Input
            className={classes.company}
            variant="h1"
            rows={6}
            value={author}
            onChange={({ target }) => setAuthor(target.value)}
            onBlur={() => handleSubmit()}
          />
        </Typography>
        <Typography
          className={classes.subtitle}
          variant="caption"
          color="textSecondary"
        >
          <Input
            className={classes.company}
            variant="h1"
            rows={6}
            value={position}
            onChange={({ target }) => setPosition(target.value)}
            onBlur={() => handleSubmit()}
          />
          <Input
            className={classes.company}
            variant="h1"
            rows={6}
            value={company}
            onChange={({ target }) => setCompany(target.value)}
            onBlur={() => handleSubmit()}
          />
        </Typography>
      </Grid>
      <Grid item xs>
        <Button variant="outlined" color="primary" onClick={() => handleDelete()}>
          <FontAwesomeIcon icon={faTrash} />
        </Button>
      </Grid>
      <Grid item className={classes.container} spacing={2} container>
        <Grid item>
          <FontAwesomeIcon className={classes.quote} icon={faQuoteLeft} />
        </Grid>
        <Grid item xs>
          <Typography>
            <Input
              className={classes.company}
              variant="h1"
              textarea
              rows={6}
              value={comment}
              onChange={({ target }) => setComment(target.value)}
              onBlur={() => handleSubmit()}
            />
          </Typography>
        </Grid>
      </Grid>

    </Grid>
  );
};

Edit.propTypes = {
  QUOTE,
};

export default Edit;
